import styled from "styled-components";

export const Container = styled.div`
  padding: 20px 20px 50px 20px;
  box-shadow: rgba(0, 0, 0, 0.15) -3px 3px 5px 0px;
  /* padding: 15px; */
  background-color: rgb(255, 255, 255);
`;

